import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Data(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.21 1c.814 0 1.583.304 2.165.854l4.474 4.236v.001c.593.56.932 1.343.932 2.145V20c0 1.654-1.452 3-3.237 3H6.238C4.453 23 3 21.654 3 20V4c0-1.654 1.453-3 3.238-3h7.972zm0 2H6.238C5.555 3 5 3.448 5 4v16c0 .552.555 1 1.238 1h12.306c.682 0 1.237-.448 1.237-1V8.236a.947.947 0 00-.307-.693L15 3.308A1.153 1.153 0 0014.21 3zm-4.195 7.225c.453 0 .87.054 1.252.164.38.109.716.297 1.004.563l-.88.96a1.747 1.747 0 00-.576-.4c-.214-.09-.48-.136-.8-.136-.267 0-.508.046-.724.137a1.614 1.614 0 00-.912.96 2.075 2.075 0 00-.124.727c0 .267.04.51.124.733a1.63 1.63 0 00.912.956c.216.09.457.136.724.136a2.434 2.434 0 001.176-.281v-.92h-1.016v-1.152h2.216v2.96a4.505 4.505 0 01-1.152.416c-.4.086-.808.128-1.224.128a3.48 3.48 0 01-1.224-.208 2.78 2.78 0 01-.968-.596 2.71 2.71 0 01-.636-.94 3.205 3.205 0 01-.228-1.232 3.2 3.2 0 01.228-1.232c.152-.367.364-.681.636-.94.272-.258.594-.457.968-.595a3.48 3.48 0 011.224-.208zm5.584.144c.245 0 .492.017.74.05.248.037.47.106.668.209.197.105.357.25.48.437.123.186.184.434.184.744 0 .319-.09.585-.268.796a1.477 1.477 0 01-.708.452v.016c.186.026.356.079.508.156a1.272 1.272 0 01.644.716c.058.16.088.33.088.51 0 .3-.064.549-.192.75a1.52 1.52 0 01-.496.484 2.19 2.19 0 01-.684.264c-.254.053-.506.08-.756.08h-2.32v-5.664h2.112zm.08 3.32h-.944v1.288h1.12c.096 0 .193-.011.292-.032a.78.78 0 00.268-.113.602.602 0 00.272-.519.503.503 0 00-.1-.324.641.641 0 00-.252-.19 1.364 1.364 0 00-.328-.087 2.615 2.615 0 00-.328-.023zm-.096-2.265h-.848v1.208h.904c.096 0 .19-.01.284-.031a.807.807 0 00.252-.104.553.553 0 00.18-.192.581.581 0 00.068-.288.52.52 0 00-.076-.292.54.54 0 00-.196-.181.937.937 0 00-.272-.091 1.612 1.612 0 00-.296-.03z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoData = React.memo(Data);
export default MemoData;